module.exports = __webpack_public_path__ + "media/images/rank_b-df25a6db21229588c8eca13f88748c5a.gif";